import { useContext } from 'react';

import SearchContext from './search.context';

function useSearch() {
  const context = useContext(SearchContext);

  if (!context) {
    throw new Error('useSearch must be used within SearchContext');
  }

  return context;
}

export default useSearch;